const ASPECT_DELIMITER = 'x';
const util = {
    getAspectRatioData(aspectRatio = '4x3') {
        const arParts = aspectRatio.split(ASPECT_DELIMITER).map((val) => (parseInt(val, 10)));
        const ratio = arParts[0] / arParts[1];
        return {
            ratio,
            ratioString: aspectRatio,
            heightDimension: arParts[1],
            widthDimension: arParts[0],
            heightMultiplier: arParts[1] / arParts[0],
            widthMultiplier: ratio
        };
    },

    getImageBoundSide(imageAspectRatio, carouselAspectRatio) {
        return imageAspectRatio < carouselAspectRatio ? 'width' : 'height';
    },

    supportsNativeClamp() {
        /* istanbul ignore next */
        if (typeof document !== 'undefined' && typeof document.documentElement !== 'undefined') {
            return typeof (document.documentElement.style.webkitLineClamp) !== 'undefined';
        }
        /* istanbul ignore next */
        return false;
    }
};

export default util;
